// /index.js
import initCommonScript from "./libs/common";
import initAnimationScript from "./libs/animation";

const body = document.body;

// トップページの場合のみアニメーション実行
if (body.classList.contains("home")) {
  initAnimationScript().then(() => {
    initCommonScript();
  });
} else {
  // それ以外のページは commonScript のみ
  initCommonScript();
}
